import * as React from 'react';
import { InnerPageComponent } from './page.component';
import { NavigationContext } from '@src/context/navigation-store/navigation-store';

export interface Props {}

function Component(props: Props) {
  const { pageData, breadcrumbItems, navigateToRoute } = React.useContext(NavigationContext);
  return (
    <InnerPageComponent
      {...props}
      pageData={pageData}
      navigateToRoute={navigateToRoute}
      breadcrumbItems={breadcrumbItems}
    />
  );
}

export const PageComponent = Component;
